export const lottieDefaultOptions = {
  loop: true,
};
